// extracted by mini-css-extract-plugin
export default {"formCont":"NewBot_formCont__Zb3Ci","select-container":"NewBot_select-container__-J3gd","select":"NewBot_select__WL7V1","disabled-select":"NewBot_disabled-select__mxWWt"};